// extracted by mini-css-extract-plugin
module.exports = {"creditsBar":"creditsBar--kmjvd"};